import { computed, makeObservable } from "mobx";
import { IUserListingModel, ISearchParams, UserListingModel } from '@common/models';
import { StandardSearchStore } from "@common/stores";
import { SearchService } from "@common/services/searchService";
import { ISelectOption, ISelectOptionString } from "@common/components/forms";
import { IQueryCacheStoreInit } from "@common/stores/QueryCacheStore";
import { StringUtility } from "@common/utils";

export interface IUserSearchAllFilter {
    emailAddress?: string
    firstName?: string
    lastName?: string
    authRoleID?: number
    employmentstatusactive?: boolean
}

export interface IUserSearchOrgFilter extends IUserSearchAllFilter {
    ovid?: number
    osid?: number
    ocode?: string
    otid?: number
    uid?: number
}


const defaultUserAllSearchFilter: IUserSearchAllFilter = {
    emailAddress: "",
    firstName: "",
    lastName: "",
    authRoleID: undefined,
    employmentstatusactive: undefined
}

const defaultUserOrgSearchFilter: IUserSearchOrgFilter = {
    emailAddress: "",
    firstName: "",
    lastName: "",
    authRoleID: undefined,
    employmentstatusactive: undefined,
    ovid: 1,
    osid: 1,
    ocode: undefined,
    otid: undefined,
    uid: undefined
}

const defaultSearchParams: ISearchParams = {
    skip: 0,
    top: 20,
    orderby: [{ field: "lastName", dir: "asc" }],
    search: undefined
}

export type UserSearchStoreAllInit = {
    scope: 'all'
};

export type UserSearchStoreOrgInit = {
    scope: 'org',
    organizationVersionId?: number
    organizationSourceId?: number
    organizationRelationKey?: string
    organizationTypeId?: number
}

export type UserSearchStoreInit = UserSearchStoreAllInit | UserSearchStoreOrgInit;

export interface IUserSearchStoreInit {

}

export class UserSearchStore extends StandardSearchStore<IUserSearchAllFilter | IUserSearchOrgFilter, IUserListingModel, UserListingModel> {

    @computed get userSelectOptions() {
        return _.orderBy(this.searchResults.results, 'lastName')
            .map(u => ({
                label: StringUtility.formattedUserName(u.firstName, u.lastName, u.title),
                value: u.userId
            })) as ISelectOption[];
    }

    @computed get userSelectOptionsStrings() {
        return _.orderBy(this.searchResults.results.filter(u => u.isProfileActive), 'lastName')
            .map(({ firstName, lastName, title }) => ({
                label: StringUtility.formattedUserName(firstName, lastName, title),
                value: StringUtility.formattedUserName(firstName, lastName, title)
            })) as ISelectOptionString[];
    }

    constructor(init?: UserSearchStoreAllInit | UserSearchStoreOrgInit, overrides?: Partial<UserSearchStore>, queryClientInit?: IQueryCacheStoreInit) {
        super({
            endpointUrl: (!init || init.scope === 'all' ? SearchService.SearchEndPoints.users : (init.scope === 'org' ? SearchService.SearchEndPoints.organizationUsers : SearchService.SearchEndPoints.users)),
            defaultSearchParams: { ...defaultSearchParams, ...overrides?.defaultSearchParams },
            defaultSearchFilter: !init || init.scope === 'all' ? {
                ...defaultUserAllSearchFilter
            } : (init.scope === 'org' ? {
                ...defaultUserOrgSearchFilter,
                ovid: init?.organizationVersionId,
                osid: init?.organizationSourceId,
                ocode: init?.organizationRelationKey,
                otid: init?.organizationTypeId,
            } : {}),
        },
            (result: IUserListingModel) => new UserListingModel(result),
            queryClientInit
        );
        Object.assign(this, overrides);
        makeObservable(this, undefined); //can't use autoBind in derrived class if already called in sub class.
    }
}
